import React, {useContext, useMemo} from "react";

// Components
import VideoContentGridLandscape from "../../Components/Layouts/Content/Watch/VideoFeed/VideoContentGridLandscape";
import ButtonPill from "../../Components/Buttons/ButtonPill";

// Hooks
import useFetchSpecificContentItems from "../../Hooks/Content/Watch/VideoSingle/useFetchSpecificContentItems";

// Context
import {GlobalInterfaceContext} from "../../Context/GlobalInterfaceContext";
import {UserAuthenticationContext} from "../../Context/UserAuthenticationContext";

// Constants
import {RoutePaths} from "../../Constants/RoutePaths";

const DavidIckeSeries = () => {
    const
        { isDarkMode } = useContext(GlobalInterfaceContext),
        authCtx = useContext(UserAuthenticationContext),

        // User data
        userId = authCtx.userData?.id ?? "1c624ef2-27a9-496f-b518-6f6e612078b6",
        countryCode = "GB",

        filmsIds = useMemo(
            () => [
                { type: "Series", id: 171 },
                { type: "Series", id: 154 },
                { type: "Series", id: 139 },
                { type: "Series", id: 124 },
                { type: "Series", id: 122 },
                { type: "Series", id: 121 },
                { type: "Series", id: 58 },
                { type: "Series", id: 29 },
                { type: "Series", id: 13 },
            ],
            []
        ),
        {
            items,
            loading,
            error
        } = useFetchSpecificContentItems(filmsIds, countryCode, userId);


    return (
        <div className="page page--david-icke page--david-icke-sub-page">
            <div className="david-icke__banner">
                <img src="https://storage.ickonic.com/IckonicImage/compressed/David Icke Header 04b.jpg"
                     alt="David Icke - World Renowned Author and Researcher"/>
            </div>

            <div className="page__heading">
                <h1>
                    David Icke - All Series
                </h1>

                <ButtonPill label="Back" link={RoutePaths.DavidIcke}/>
            </div>

            <VideoContentGridLandscape
                isDarkMode={isDarkMode}
                carouselItems={loading ? undefined : items}
                backgroundHex="#151515"
            />
        </div>
    )
}

export default DavidIckeSeries;
